import React, { useRef, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import { MAIN_HEADER_HEIGHT } from '../../../../../constants'
import AttachmentArea from './AttachmentArea'
import ChatPanel from './ChatPanel'
import { usePlaygroundApp } from './playgroundApp'

const useStyles = makeStyles(() => ({
  playground: {
    marginTop: '10px',
    borderTop: 'var(--border-neutral-thin)',
    display: 'grid',
    gridTemplateColumns: 'minmax(400px, 1fr) minmax(400px, 20vw)',
    maxHeight: `calc(100vh - ${MAIN_HEADER_HEIGHT + 10}px)`,
    height: `calc(100vh - ${MAIN_HEADER_HEIGHT + 10}px)`
  }
}))

function PlaygroundView () {
  const classes = useStyles()
  const playgroundApp = usePlaygroundApp()
  const containerRef = useRef(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    const onWheel = e => {
      // if horizontal swipe/scroll (e.g. two-finger swipe on mac)
      if (e.deltaX !== 0) {
        e.preventDefault()
      }
    }

    // attach with passive: false so we can preventDefault
    container.addEventListener('wheel', onWheel, { passive: false })
    return () => container.removeEventListener('wheel', onWheel)
  }, [])

  return (
    <div ref={containerRef} className={classes.playground}>
      <AttachmentArea
        isLoading={playgroundApp.attachmentDataLoading}
        attachment={playgroundApp.attachmentData}
      />
      <ChatPanel
        messages={playgroundApp.thread?.messages || []}
        onNewMessage={playgroundApp.addMessage}
        isLoading={playgroundApp.isThreadLoading}
        onJsxAttachmentClick={playgroundApp.setSelectedAttachment}
      />
    </div>
  )
}

export default PlaygroundView
